import styles from './Buttons.module.scss';
import cx from 'classnames';

const Buttons = ({ 
    children,
    onClick,
    border,
    color,
  	background,
    width,
    style,
    nospace,
    theme,
    href,
    className,
    ...props
}) => { 
  const attrs = {
    className: cx(styles.mainbtn, className, {[styles.nospace]: nospace}, styles[theme] || ''),
    style: {background, color, border, width, ...style},
    ...props
  };
  if(href){
    return (<a {...attrs} rel="noreferrer" href={href}>{children}</a>)
  } else {
    return (<button {...attrs} onClick={onClick}>{children}</button>)
  }
}

export default Buttons;